<template>
	<MfaModal v-model:show="isModalVisible" @success="handleSuccess" @error="handleError" />
</template>

<script setup lang="ts">
import MfaModal from "@/components/auth/MfaModal.vue"
import { useMfaModal } from "@/composables/auth/useMfaModal"

const { isModalVisible, handleSuccess, handleError } = useMfaModal()
</script>
